import {
  ServiceGroupsPaginated,
  ServiceGroupSummary,
  SummaryDataPaginated
} from 'types/ServiceGroupTypes';
import useHttp from '../helpers/HttpMethods';

class ServiceGroupService {
  /**
   * List service groups with filters.
   * @param {string} filter - filter in string format.
   * @returns {Promise<Response | ServiceGroupsPaginated>}
   */
  static async list(
    filter: string
  ): Promise<Response | ServiceGroupsPaginated> {
    return await useHttp().get(`/service-groups?${filter}`);
  }

  /**
   * List summary data with filters.
   * @param {string} filter - filter in string format.
   * @returns {Promise<Response | SummaryDataPaginated>}
   */
  static async listSummaryData(
    filter: string
  ): Promise<Response | SummaryDataPaginated> {
    return await useHttp().get(`/service-groups/summary-data?${filter}`);
  }

  /**
   * List service groups by user.
   * @returns {Promise<Response | ServiceGroupSummary[]>}
   */
  static async listByUser(): Promise<Response | ServiceGroupSummary[]> {
    return await useHttp().get('/service-groups/by-user');
  }

  /**
   * Create a service group.
   * @param {{name: string}} body - only one property, name.
   * @returns {Promise<ServiceGroupSummary>}
   */
  static async create(body: { name: string }): Promise<ServiceGroupSummary> {
    return await useHttp().post(body, '/service-groups');
  }

  /**
   * Edits a service group.
   * @param {{name: string, inactive: boolean}} body - two properties name and inactive.
   * @param {number} id - Service group ID.
   * @returns {Promise<Response | ServiceGroupSummary>}
   */
  static async edit(
    id: number,
    body: { name: string; inactive: boolean }
  ): Promise<Response | ServiceGroupSummary> {
    return await useHttp().put(body, `/service-groups/${id}`);
  }
}

export default ServiceGroupService;
